import Typography from "components/typography";
import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import PostItem from "../post-item";
import SearchInput from "components/inputs/search-input";
import Pagination from "components/pagination";

const Posts = () => {
  const Filters = [
    "All Blog Posts",
    "Music Tips",
    "Music News",
    "Music Industry",
    "Promotion",
    "Songwriting"
  ];
  const [activeFilter, setActiveFilter] = useState("All Blog Posts");
  const [searchInput, setSearchInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const postDetails = {
    title: "UX review presentations",
    img: "https://images.unsplash.com/photo-1505330622279-bf7d7fc918f4?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmxvZ3xlbnwwfHwwfHx8MA%3D%3D",
    description:
      "How do you create compelling presentations that wow your colleagues and impress your managers?",
    tag: "Promotion",
    date: "17 Nov 2024",
    link: "https://nnaemeka.dev"
  };
  return (
    <Container>
      <Typography
        size="4xl"
        m_size="2xl"
        weight="semibold"
        mb="3.2"
        color={Colors.white300}
      >
        Recent blog posts
      </Typography>
      <RecentBlogPostsGrid>
        <PostItem {...postDetails} />
        <PostItem {...postDetails} />
      </RecentBlogPostsGrid>
      <FilterSection>
        {Filters.map((filter, i) => {
          return (
            <FilterItem
              onClick={() => setActiveFilter(filter)}
              key={i}
              active={activeFilter === filter ? "true" : "false"}
            >
              <Typography size="4xl" m_size="lg" color={Colors.white300}>
                {filter}
              </Typography>
            </FilterItem>
          );
        })}
      </FilterSection>
      <BlogPostHeaderGroup>
        <Typography size="4xl" weight="semibold">
          All blog posts
        </Typography>
        <SearchInput
          placeholder="Search the blog"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
      </BlogPostHeaderGroup>
      <AllPostsGrid>
        <PostItem {...postDetails} />
        <PostItem {...postDetails} /> <PostItem {...postDetails} />
        <PostItem {...postDetails} /> <PostItem {...postDetails} />
        <PostItem {...postDetails} />
      </AllPostsGrid>
      <Pagination
        currentPage={currentPage}
        totalPages={10}
        onPageChange={(page) => {
          setCurrentPage(page);
        }}
      />
    </Container>
  );
};

export default Posts;

const Container = styled.div`
  width: 100%;
  padding: 0rem 10.4rem;
  margin-bottom: 9.6rem;
  @media only screen and (max-width: 769px) {
    padding: 0rem 1.6rem;
    margin-bottom: 6.4rem;
  }
`;

const RecentBlogPostsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-column-gap: 3.2rem;
  grid-row-gap: 4.8rem;
  margin-bottom: 9.6rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    grid-row-gap: 3.2rem;
    margin-bottom: 6.4rem;
  }
`;

const FilterSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3.2rem;
  margin-bottom: 5rem;
  @media only screen and (max-width: 769px) {
    overflow-x: scroll;
    justify-content: start;
    margin-bottom: 3.2rem;
  }
`;

const FilterItem = styled.div<{ active: string }>`
  padding: 1.6rem 3.2rem;
  border-radius: 6rem;
  background-color: #303030;
  border: 1px solid ${Colors.grey600};
  cursor: pointer;
  opacity: ${(props) => (props.active === "true" ? 1 : 0.2)};
  transition: opacity 0.2s ease-in-out;
  @media only screen and (max-width: 769px) {
    padding: 0.8rem 1.6rem;
    min-width: max-content;
  }
`;

const BlogPostHeaderGroup = styled.div`
  display: grid;
  grid-template-columns: 20% 20%;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4rem;
  @media only screen and (max-width: 769px) {
    display: flex;
    flex-direction: column-reverse;
    gap: 3.2rem;
    margin-bottom: 3.2rem;
    align-items: start;
  }
`;

const AllPostsGrid = styled(RecentBlogPostsGrid)`
  grid-template-columns: 1fr 1fr 1fr;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
  }
`;
